module.exports = __webpack_public_path__ + "static/media/Thonburi_Bold.b082b5d7.svg";